/**
 * Company custom fields on screen: the editor for record forms and the
 * read-only view for detail pages. Definitions come from
 * `GET /api/admin/custom-fields/mine?entity=` (`customFieldsMinePath`); the
 * rules (formatting, columns, filters) are in `@lognai/plugin-sdk`.
 */

export { CustomFieldInput, type CustomFieldInputProps, type SimpleFieldDef } from './CustomFieldInput';
export { CustomFieldsEditor, type CustomFieldsEditorProps, type CustomFieldFormValues } from './CustomFieldsEditor';
export { CustomFieldsView, type CustomFieldsViewProps } from './CustomFieldsView';

/** The heading every record page and form gives its custom fields, so all modules read the same. */
export const CUSTOM_FIELDS_TITLE = 'Additional info';

export const customFieldsMinePath = (entity: string): string =>
  `/api/admin/custom-fields/mine?entity=${encodeURIComponent(entity)}`;

/**
 * Turns a failed save's validation error (`{ field, message }`) into the
 * `errors` map the editor shows, or an empty map for other errors.
 */
export const customFieldErrors = (error: unknown): Record<string, string> => {
  const e = error as { field?: unknown; message?: unknown; details?: { field?: unknown } } | null;
  const field = typeof e?.field === 'string' ? e.field : typeof e?.details?.field === 'string' ? e.details.field : null;
  return field && field.startsWith('customFields') && typeof e?.message === 'string' ? { [field]: e.message } : {};
};
